import { type Review as TReview } from "@omni/types/api/reviews/bff/response/review.model";
import { cn } from "@omni/utils/styles";

import { Divider } from "@/components/General/Divider/divider.component";
import { Col } from "@/components/General/Grid/col.component";
import { Modal } from "@/components/General/Modal/modal";
import { Pagination } from "@/components/General/Pagination/pagination.container";
import { PAGE_SIZE } from "@/components/Product/Reviews/reviews.config";
import { ReviewAuthorModel } from "@/types/service/reviews/reviewAuthor.model";

import { Review } from "../review/review.component";

type ReviewerModalComponentProps = {
    range: number;
    reviewer: ReviewAuthorModel;
    open: boolean;
    reviews: Array<TReview>;
    totalReviews: number;
    loading: boolean;
    loadMore: () => Promise<void>;
    toggleHandler: (open: boolean) => void;
};

export const ReviewerModalComponent = ({
    range,
    reviewer,
    open,
    reviews,
    totalReviews,
    loading,
    loadMore,
    toggleHandler
}: ReviewerModalComponentProps) => {
    return (
        <Modal
            title={reviewer.name}
            open={open}
            setOpen={toggleHandler}
            scrollable={true}
        >
            <div
                className={cn(
                    "tw:sticky tw:top-0 tw:bg-background tw:z-10 tw:pt-2"
                )}
            >
                <Divider className={cn("tw:mb-4 tw:mt-0")} />
            </div>
            <div className={cn("tw:h-fit")}>
                {reviews.map((review) => (
                    <Col
                        key={review.id}
                        className={cn(
                            "tw:not-first-of-type:mt-4 tw:not-first-of-type:pt-4 tw:not-first-of-type:border-t tw:not-first-of-type:border-grey-light"
                        )}
                    >
                        <Review
                            review={review}
                            range={range}
                            showLink={true}
                            showProductImage={true}
                        />
                    </Col>
                ))}
            </div>
            {totalReviews > 2 && (
                <Pagination
                    className={cn("tw:mt-4")}
                    currentNumberOfHits={reviews.length}
                    totalNumberOfHits={totalReviews}
                    hitsPerPage={PAGE_SIZE}
                    loading={loading}
                    onLoadMore={loadMore}
                />
            )}
        </Modal>
    );
};
